import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
    pages: [],
};

const slice = createSlice({
    name: 'adminPages',
    initialState,
    reducers: {
        setPages(state, action) {
            state.pages = action.payload
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    setPages,
} = slice.actions;